import { render, staticRenderFns } from "./HostReservations.vue?vue&type=template&id=21d126e4&scoped=true&"
import script from "./HostReservations.vue?vue&type=script&lang=ts&"
export * from "./HostReservations.vue?vue&type=script&lang=ts&"
import style0 from "./HostReservations.vue?vue&type=style&index=0&id=21d126e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d126e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDivider,VFlex,VIcon,VLayout})
